import * as React from 'react'
import { render } from 'react-dom'
import 'sanitize.css/sanitize.css'
import Router from './Router'
import { parse } from 'qs'

// IE11 does not support URL constructor. Extract the query params by hand.
const params = parse(window.location.search.substring(1), { depth: 0 })

const error = (params.error as string) || ''
const kcMessage = (params.kcMessage as string) || ''
const loggedOut = params.loggedOut === 'true'

// Process Login Session JWT
const jwtFragment = (window.location.hash || '').split('login_session_token=')[1]
const jwt = jwtFragment ? jwtFragment : window.sessionStorage.getItem('login-ui-session') || ''
window.sessionStorage.setItem('login-ui-session', jwt)
// reset url to hide jwt (it's not sensitive, but it is ugly)
history.pushState('', document.title, window.location.pathname)

render(<Router jwt={jwt} error={error} kcMessage={kcMessage} loggedOut={loggedOut} />, document.getElementById('app'))
